"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _List = require("./List");

var _decorators = require("decorators");

var _AccountList = babelHelpers.interopRequireWildcard(require("./AccountList"));

var _momentTimezone = babelHelpers.interopRequireDefault(require("moment-timezone"));

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _temp;

var PrefixedAccountList = function PrefixedAccountList(_ref) {
  var prefix = _ref.prefix,
      accounts = _ref.accounts;
  return accounts && accounts.length ? _react.default.createElement("span", null, prefix, _react.default.createElement(_AccountList.default, {
    accounts: accounts
  })) : null;
};

var EventStartingSoonItem = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(EventStartingSoonItem, _Component);

  function EventStartingSoonItem() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, EventStartingSoonItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(EventStartingSoonItem)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "item", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "onSelected", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "asLink", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "selected", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(EventStartingSoonItem, [{
    key: "render",
    value: function render() {
      var d = _momentTimezone.default.tz(this.item.endingAt, _momentTimezone.default.tz.guess());

      return _react.default.createElement(_List.NotificationItem, {
        selected: this.selected,
        asLink: this.asLink,
        onSelected: this.onSelected,
        item: this.item,
        overlayType: "success",
        overlay: "date_range"
      }, 'The event ', _react.default.createElement("span", {
        className: "catalogItem"
      }, this.item.catalogItem.title), this.item.course ? ' on ' : null, this.item.course ? _react.default.createElement("span", {
        className: "catalogItem"
      }, this.item.course.title) : null, ' ', _react.default.createElement(PrefixedAccountList, {
        prefix: "with ",
        accounts: this.item.withPerson
      }), ' ended at ', _react.default.createElement("span", {
        className: "when"
      }, d.format('MMMM D, YYYY'), !this.item.allDay && " at ".concat(d.format('h:mmA'))), '.');
    }
  }], [{
    key: "notificationObject",
    value: function notificationObject(_ref2) {
      var _this2 = this;

      var item = _ref2.item;
      return Promise.all([_List.NotificationItem.notificationObject({
        item: item,
        overlayType: 'success',
        overlay: 'date_range'
      })]).then(function (_ref3) {
        var _ref4 = babelHelpers.slicedToArray(_ref3, 1),
            notificationObject = _ref4[0];

        var d = _momentTimezone.default.tz(_this2.item.endingAt, _momentTimezone.default.tz.guess());

        return Object.assign(notificationObject, {
          body: ['The event', item.catalogItem.title, item.course ? " on ".concat(item.course.title) : '', item.withPerson && item.withPerson.length ? 'with ' + _AccountList.default.format(item.withPerson) : '', 'ended at', d.format('MMMM D, YYYY') + (item.allDay ? '.' : ''), item.allDay ? '' : 'at ' + d.format('h:mmA') + '.'].join(' ').split(/\s+/g).filter(function (v) {
            return !!v;
          }).join(' ')
        });
      });
    }
  }]);
  return EventStartingSoonItem;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "item", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "onSelected", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "asLink", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "selected", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
})), _class);
exports.default = EventStartingSoonItem;